import { Controller } from "@hotwired/stimulus"

export default class LightboxController extends Controller {
  static targets = ["overlay", "image", "caption", "trigger"]
  static values = { index: Number }
  static swipeThresholds = { x: 30, y: 100 }

  connect() {
    this.indexValue = 0
  }

  open(event) {
    event.preventDefault()
    this.indexValue = this.triggerTargets.indexOf(event.currentTarget)
    this.#render()
    this.overlayTarget.classList.remove("hidden")
    requestAnimationFrame(() => this.overlayTarget.classList.add("opacity-100"))
  }

  close() {
    this.overlayTarget.classList.remove("opacity-100")
    this.overlayTarget.classList.add("hidden")
  }

  closeBackdrop(event) {
    if (event.target === this.overlayTarget) this.close()
  }

  next() {
    this.#step(1)
  }

  previous() {
    this.#step(-1)
  }

  #step(delta) {
    this.indexValue =
      (this.indexValue + delta + this.triggerTargets.length) %
      this.triggerTargets.length
    this.#render()
  }

  startSwipe(event) {
    this.startX = event.clientX
    this.startY = event.clientY
    this.swiped = false
    this.dragging = true
  }

  trackSwipe(event) {
    if (this.swiped) return
    const dx = event.clientX - this.startX
    const dy = event.clientY - this.startY
    if (
      Math.abs(dx) >= this.constructor.swipeThresholds.x &&
      Math.abs(dy) <= this.constructor.swipeThresholds.y
    ) {
      if (this.dragging) {
        dx < 0 ? this.next() : this.previous()
        this.swiped = true
      }
    }
  }

  endSwipe() {
    this.swiped = false
    this.dragging = false
  }

  #render() {
    const el = this.triggerTargets[this.indexValue]
    this.imageTarget.style.opacity = 0
    if (this.imageTarget.complete) {
      requestAnimationFrame(() => (this.imageTarget.style.opacity = 1))
    } else {
      this.imageTarget.addEventListener(
        "load",
        () => requestAnimationFrame(() => (this.imageTarget.style.opacity = 1)),
        { once: true }
      )
    }
    this.imageTarget.src = el.dataset.url
    this.captionTarget.textContent = el.dataset.caption || ""
  }
}
